import {fetchCPTFilter, fetchCycleFilter, fetchFilterValues} from "../network/LineHaulNetworkAPI";
import {getRemovedStates, removeFilters} from "../../util/FilterUtil";

export const LineHaulFilterReducer = (state, action) => {
    switch (action.type) {
        case "SELECT_SPLIT":
            let currentSelection = action.Split
            if (currentSelection.length > 2) {
                currentSelection = currentSelection.slice(1, currentSelection.length)
            }
            let removedStates = getRemovedStates(currentSelection, state)
            return {...state, Split: currentSelection, ...removedStates}
        case "SELECT_PACKAGE_SIZE":
            return  {...state, PackageSize: action.PackageSize}
         case "SELECT_STATION_CODE":
            return  {...state, StationCode: action.StationCode}
        case "SELECT_EAD":
            return  {...state, EAD: action.EAD}
        case "SELECT_CYCLE":
            return  {...state, Cycle: action.Cycle}
        case "SELECT_CPT":
            return  {...state, CPT: action.CPT}
        case "SELECT_CLUSTER":
            return  {...state, Cluster: action.Cluster}
        case "SELECT_OTHER_ATTRIBUTES":
            return  {...state, OtherAttributes: action.OtherAttributes}
        case "REMOVE_FILTER":
        {
            const {key, value} = action.data
            state[key] = state[key].filter(item => item !== value)
            const newItem = state[key].filter(item => item !== value)
            return {
                ...state,
                [key] : newItem
            }
        }
        case "REMOVE_ALL_FILTER":
            return removeFilters(state);
        case "LOAD_VIEW":
            fetchFilterValues(action.data.dispatcher)
            return state
        case "LOAD_CYCLE_VIEW":
            fetchCycleFilter(action.data.dispatcher)
            return state
        case "LOAD_CPT_VIEW":
            fetchCPTFilter(action.data.dispatcher)
            return state
        case "RECEIVE_FILTER_FOR_LINEHAUL":
            return {...state, Filters: {...state.Filters, ...action.data}}
        case "RECEIVE_CYCLE":
            return {...state, Filters: {...state.Filters, Cycle: action.data}}
        case "RECEIVE_CPT":
            return {...state, Filters: {...state.Filters, CPT: action.data}}
        case "ASSIGN_LABEL":
            return {...state, CPTLabel: action.data.CPTLabel}
        case 'ASSIGN_FILTER_IDENTIFIER':
            return {...state, filterIdentifier: action.data.filterIdentifier}
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/components/linehaul/reducers/LineHaulFilterReducer.js